import { DateTime } from 'luxon'

export const formatDate = (date: number) => {
  return DateTime.fromMillis(date).toFormat('dd.MM.yyyy')
}
